import moment from 'moment'
import { APPLICATION_TYPES, FLAGS, LEVEL_TYPES } from '@/services/constants.service'

const initValue = {
  value: '',
  guid: null,
  item: null
}

const getCompetenceName = (competence) => {
  const { code = '', name } = competence
  const title = name.display || ''

  const competenceName = `${code} ${title}`

  return competenceName.trim()
}

export const examFormValuesSerializer = ({
  accred_comps: accredComps = null,
  de_center: deCenter = null,
  day_cm1: dayCm1,
  experts = [],
  flags = [],
  guid = null,
  main_expert: mainExperts,
  name = null,
  status
}) => {
  const applicationType = []
  let center = { ...initValue, visible: true }
  let codeType = null
  let competence = initValue
  const complexityLevel = accredComps.complexity_level || null
  let mainExpertGuid = null

  if (accredComps && accredComps.competency) {
    competence = {
      guid: accredComps.competency.guid || null,
      item: accredComps.competency || null,
      value: getCompetenceName(accredComps.competency) || ''
    }
  }

  if (deCenter) {
    center = {
      guid: deCenter.guid || null,
      item: deCenter || null,
      value: deCenter.name.display || '',
      visible: typeof deCenter.visible === 'boolean' ? deCenter.visible : true
    }
  }

  const types = Object.values(APPLICATION_TYPES)
  types.forEach(type => {
    if (flags.includes(type)) {
      applicationType.push(type)
    }
  })

  const codeTypesVals = Object.values(LEVEL_TYPES)
  codeTypesVals.forEach(el => {
    if (flags.includes(el)) {
      codeType = el
    }
  })

  if (mainExperts && mainExperts.user_info) {
    mainExpertGuid = mainExperts.user_info.guid
  }

  return {
    application_type: applicationType,
    codeType,
    competence,
    complexity_level: complexityLevel,
    day_cm1: dayCm1 ? new Date(dayCm1) : null,
    de_center: center,
    experts: experts || [],
    guid,
    main_expert: mainExpertGuid,
    flags: ['secondary_degree', 'state_standard'],
    name: name ? name.translate.ru : '',
    remote_experts: flags.includes(FLAGS.REMOTE_EXPERTS),
    remote_members: flags.includes(FLAGS.REMOTE_MEMBERS),
    status
  }
}

export const examSubmitSerializer = ({
  application_type: applicationType,
  codeType,
  competence,
  complexity_level: complexityLevel,
  day_cm1: dayCm1,
  de_center: deCenter,
  name,
  remote_experts: remoteExpets,
  remote_members: remoteMembers,
  status
}, oldExam) => {
  const date = moment(dayCm1).format()

  const flags = [
    'state_standard',
    'regional_exam',
    'secondary_degree',
    ...applicationType
  ]

  let level = LEVEL_TYPES.INTERMEDIATE_CERT
  if (applicationType[0] === APPLICATION_TYPES.FINAL && codeType) {
    level = codeType
  }

  flags.push(level)

  if (remoteExpets) {
    flags.push(FLAGS.REMOTE_EXPERTS)
  }

  if (remoteMembers) {
    flags.push(FLAGS.REMOTE_MEMBERS)
  }

  return {
    accred_comps: {
      competency: competence.item,
      complexity_level: complexityLevel
    },
    day_cm1: date,
    de_center: {
      guid: deCenter.item.guid
    },
    flags,
    name: {
      translate: {
        ru: name
      }
    },
    status,
    started_at: oldExam.started_at,
    ended_at: oldExam.ended_at,
    qualification: oldExam.qualification,
    evaluation_in_new_cis: oldExam.evaluation_in_new_cis,
    blockingComment: oldExam.blockingComment
  }
}
